// extracted by mini-css-extract-plugin
module.exports = {"navigationToolbar":"MultiInstanceNavigationWidget_navigationToolbar__cLH7t"};